import React from 'react';
import UserSnapshotCard from './cards/UserSnapshotCard';
import CookingSnapshotCard from './cards/CookingSnapshotCard';
import EconomySnapshotCard from './cards/EconomySnapshotCard';
import ExpertSnapshotCard from './cards/ExpertSnapshotCard';

export default function SnapshotCardsRow({ data, onOpenDrawer }) {
  return (
    <section className="grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-4">
      <UserSnapshotCard data={data.user} onOpenDrawer={() => onOpenDrawer('user')} />
      <CookingSnapshotCard data={data.cooking} onOpenDrawer={() => onOpenDrawer('cooking')} />
      <EconomySnapshotCard data={data.economy} onOpenDrawer={() => onOpenDrawer('economy')} />
      <ExpertSnapshotCard data={data.expert} onOpenDrawer={() => onOpenDrawer('expert')} />
    </section>
  );
}
